import { t as __t } from "i18next";
import Aos from "aos";
import "aos/dist/aos.css";
import "./styles/index.scss";
import { memo, useEffect, useRef, useState } from "react";
import ScrollToTop from "./components/common/ScrollTop";
import ScrollTopBehaviour from "./components/common/ScrollTopBehaviour";
import { useTranslation } from "react-i18next";
import { Provider, useDispatch, useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter, Routes, Route, Outlet, useLocation, Navigate } from "react-router-dom";
import LoginPage from "./route/login";
import DashboardPage from "./route/dashboard";
import RedisPage from "./route/redis"
import HomeMobileEditor from "./route/settings/mobile";
import ChangePasswordPage from "./route/settings/change-password";
import UserPage from "./route/settings/users";
import LifeContractPage from "./route/contractControll/checkLifeContract";
import LifeContractPaymentDetailPage from "./route/contractControll/lifeContractPaymentDetail";

import VehicleContractPage from "./route/contractControll/checkVehicleContract";
import LifeContractListPage from "./route/contractControll/lifeContract"
import CaseStatementContractListPage from "./route/contractControll/caseIdiomsContract"
import CaseStatementContractMangementPage from "./route/contractControll/caseIdiomsContract/manage"
import CaseStatementContractDetailPage from "./route/contractControll/caseIdiomsContract/detail"


import VehicleContractListPage from "./route/contractControll/vehicleContract"
import VehicleContractClamePage from "./route/contractControll/vehicleContract/clame"
import VehicleContractMangementPage from "./route/contractControll/vehicleContract/manage"
import VehicleContractRenewPage from "./route/contractControll/vehicleContract/renew"
import VehicleClaimCenterPage from "./route/contractControll/vehicleClaimCenter"
import LifeContractMangementPage from "./route/contractControll/lifeContract/manage"
import LifeContractClamePage from "./route/contractControll/lifeContract/clame"
import LifeContractClaimTrackingPage from "./route/contractControll/lifeContract/claimTracking"
import UserManagePage from "./route/settings/users/manage";
import VehicleBrandPage from "./route/settings/vehicle-brand";
import VehicleBrandMangementPage from "./route/settings/vehicle-brand/manage";
import PoliciesPage from "./route/settings/policies";
import PoliciesMangementPage from "./route/settings/policies/manage";
import AgentSpecialCommisionPage from "./route/settings/special-agent-commission";
import AgentSpecialCommisionManagePage from "./route/settings/special-agent-commission/manage";
import ApprovedAgentSpecialCommisionManagePage from "./route/approveds/special-agent-commission";
import ApprovedCancelAgentPage from "./route/approveds/agent";

import ApprovedListLifeInsurancePage from "./route/approveds/life-insurance";
import ApprovedListVehicleInsurancePage from "./route/approveds/vehicle-insurance";

import ApprovedLifeInsurancePage from "./route/approveds/life-insurance/approve";
import ApprovedVehicleInsurancePage from "./route/approveds/vehicle-insurance/approve";

import ApprovedCancelInsurancePage from "./route/approveds/cancelvehicleContract";

import UserPermissionPage from "./route/settings/user-permission";
import UserPermissionManagePage from "./route/settings/user-permission/manage";
import WebMenuManagerPage from "./route/settings/web-menu";
import ActionLogPage from "./route/settings/action-log";
import AppControlPage from "./route/settings/app-control";
import AppControlManagePage from "./route/settings/app-control/manage";
import DiscountPage from "./route/settings/discounts";
import DiscountManagePage from "./route/settings/discounts/manage";
import NotificationPage from "./route/notifications";
import NotificationManagePage from "./route/notifications/manage";
import AccountServicePage from "./route/callcenters/accounts";
import CustomerServicePage from "./route/callcenters/customers";
import CustomerManagePage from "./route/callcenters/customers/manage";
import PaymentHistoryPage from "./route/callcenters/payment-history";
import ManualPaymentPage from "./route/callcenters/manual-payment";
import AgentServicePage from "./route/callcenters/agents";
import AgentServiceManagePage from "./route/callcenters/agents/manage";
import AgentReportPage from "./route/report/agent";
import CustomerReportPage from "./route/report/customer";
import ContractNearExpiredReportPage from "./route/report/contractNearExpired";
import RiskVehicleContractReportPage from "./route/report/riskVehicleContract";
import AgentCommissionReportPage from "./route/report/agentCommission";
import LifeContractReportPage from "./route/report/lifeContract";
import VehicleContractReportPage from "./route/report/vehicleContract";
import ClameReportPage from "./route/report/clame";
import VehicleReportClaimSummary from "./route/report/vehicleReportClaimSummary";
import VehicleReportSummary from "./route/report/vehicleReportSummary ";


import Logout from "./route/logout"
import { handleGetCookie } from "./utils/commonUtil";
import { setData } from "./redux/loginSlice";
import useSessionManager from "./utils/useSessionManager";
import SessionWarningModal from "./components/common/SessionWarningModal";
import SwalAlert from "./components/common/alert";
import CommissionDetailPageRoute from "./route/commision/CommissionPayoutDetailPage";
import CommissionPayoutHistoryPageRoute from "./route/commision/CommissionPayoutHistoryPage";
import CreateCommissionPayoutPageRoute from "./route/commision/CreateCommissionPayoutPage";
import CommissionPayoutViewPageRoute from "./route/commision/CommissionPayoutViewPage";
import PersistentListRoute from "./components/common/PersistentListRoute";
import GlobalDocumentPreview from "./components/document-preview";
import RoutePermissionGuard from "./components/common/RoutePermissionGuard";
import "./styles/brand-theme.css";
import LegacyLifeEntryPage from "./route/legacyLifeEntry";
import LegacyLifeEntryListPage from "./route/legacyLifeEntry/list";
import LegacyLifeEntryApprovalPage from "./route/legacyLifeEntry/approval";
import LegacyLifeEntryApprovePage from "./route/legacyLifeEntry/approve";
import LegacyLifeBillEntryPage from "./route/legacyLifeEntry/bill";
import LegacyLifeBillApprovePage from "./route/legacyLifeEntry/billApprove";
if (typeof window !== "undefined") {
	import("bootstrap");
}

const RootRoute = () => {
	const authData = handleGetCookie("auth");
	const isAuthenticated = Boolean(authData?.accessToken && authData?.user?.userId);

	return isAuthenticated
		? <Navigate to="/admin/dashboard" replace />
		: <LoginPage />;
};

const ProtectedRoute = ({ onchange }) => {
	const dispath = useDispatch();
	const location = useLocation();
	const isAuthenticated = handleGetCookie('auth') ? true : false;
	if (!isAuthenticated) {
		console.log("logout")
		onchange(null)
		window.location.href = "/logout"
	}
	const authData = handleGetCookie('auth');
	if (authData?.user?.userId) {
		dispath(setData(authData))
	}
	return isAuthenticated ? <><RoutePermissionGuard><Outlet /></RoutePermissionGuard> <ShowWarning /></> : <Logout />;
};


const ShowWarning = () => {
	const handleLogout = () => {
		window.location.href = "/logout";
	};
	const { showWarning, resetTimers } = useSessionManager(handleLogout);

	const handleContinue = () => {
		resetTimers(); // extend session
	};

	return showWarning ? SwalAlert.confirm(__t("uiText.text001"), __t("uiText.text002"), handleContinue, handleLogout) : ""
};
function App() {
	const dispath = useDispatch();
	const { t, i18n } = useTranslation()
	const onChange = () => {
	}

	return (
		<>
			<div className={`page-wrapper ${i18n.language == "en" ? 'font-en' : 'font-la'}`}>
				<BrowserRouter>
					<Routes>
						<Route path="/">
							<Route index element={<RootRoute />} />
						</Route>
						<Route path="/logout">
							<Route index element={<Logout />} />
						</Route>
						<Route path="admin" element={<ProtectedRoute onchange={onChange} />}>

							{/* 1. ໜ້າຫຼັກ */}
							<Route path="dashboard" element={<DashboardPage />} />

							{/* 2. ຄວບຄຸມສັນຍາ */}
							<Route path="contractControl">
								<Route path="checkLifeContract">
									<Route index element={<LifeContractPage />} />
								</Route>
								<Route path="checkLifeContractLink/:data">
									<Route index element={<LifeContractPage />} />
								</Route>
								<Route path="lifeContractPaymentDetail">
									<Route index element={<LifeContractPaymentDetailPage />} />
								</Route>
								<Route path="checkVehicleContract">
									<Route index element={<VehicleContractPage />} />
								</Route>
								<Route path="checkVehicleContractLink/:data">
									<Route index element={<VehicleContractPage />} />
								</Route>
								<Route path="lifeInsurance" element={<PersistentListRoute element={<LifeContractListPage />} />}>
									<Route path="clame/:data" element={<LifeContractClamePage />} />
									<Route path="claimTracking/:id" element={<LifeContractClaimTrackingPage />} />
									<Route path="detail/:data" element={<LifeContractPage />} />
									<Route path="save" element={<LifeContractMangementPage />} />
									<Route path="save/:id" element={<LifeContractMangementPage />} />
								</Route>
								<Route path="vehicleInsurance" element={<PersistentListRoute element={<VehicleContractListPage />} />}>
									<Route path="clame/:data" element={<VehicleContractClamePage />} />
									<Route path="save" element={<VehicleContractMangementPage />} />
									<Route path="save/:id" element={<VehicleContractMangementPage />} />
									<Route path="renew/:id" element={<VehicleContractRenewPage />} />
									<Route path="detail/:data" element={<VehicleContractPage />} />
									<Route path="claims/:contractNumber" element={<PersistentListRoute element={<VehicleClaimCenterPage />} />}>
										<Route path="case/save" element={<CaseStatementContractMangementPage />} />
										<Route path="case/save/:id" element={<CaseStatementContractMangementPage />} />
										<Route path="clame/:data" element={<VehicleContractClamePage />} />
									</Route>
								</Route>
								<Route path="caseStatement" element={<PersistentListRoute element={<CaseStatementContractListPage />} />}>
									<Route path="clame/:data" element={<VehicleContractClamePage />} />
									<Route path="detail/:id" element={<CaseStatementContractDetailPage />} />
									<Route path="save" element={<CaseStatementContractMangementPage />} />
									<Route path="save/:id" element={<CaseStatementContractMangementPage />} />
								</Route>
							</Route>

							{/* 3. ອະນຸມັດ */}
							<Route path="approved">
								<Route path="cancelAgent">
									<Route index element={<ApprovedCancelAgentPage />} />
								</Route>
								<Route path="agentSpecialCommision">
									<Route index element={<ApprovedAgentSpecialCommisionManagePage />} />
								</Route>
								<Route path="lifeInsurance" element={<PersistentListRoute element={<ApprovedListLifeInsurancePage />} />}>
									<Route path="approveLifeInsurance/:id">
										<Route index element={<ApprovedLifeInsurancePage />} />
									</Route>
								</Route>
								<Route path="vehicleInsurance" element={<PersistentListRoute element={<ApprovedListVehicleInsurancePage />} />}>
									<Route path="approveVehicleInsurance/:id">
										<Route index element={<ApprovedVehicleInsurancePage />} />
									</Route>
								</Route>
								<Route path="cancelVehicleContract">
									<Route index element={<ApprovedCancelInsurancePage />} />
								</Route>
							</Route>
							{/* Legacy Life Entry - isolated from existing life insurance flow */}
							<Route path="legacyLifeEntry">
								<Route path="list" element={<LegacyLifeEntryListPage />} />
								<Route path="save" element={<LegacyLifeEntryPage />} />
								<Route path="save/:id" element={<LegacyLifeEntryPage />} />
								<Route path="approval" element={<LegacyLifeEntryApprovalPage />} />
								<Route path="bill" element={<LegacyLifeBillEntryPage />} />
								<Route path="bill/:id" element={<LegacyLifeBillEntryPage />} />
								<Route path="approve/:id" element={<LegacyLifeEntryApprovePage />} />
								<Route path="approve-bill/:id" element={<LegacyLifeBillApprovePage />} />
							</Route>
							{/* 4. ແຈ້ງເຕືອນ */}
							<Route path="notification" element={<PersistentListRoute element={<NotificationPage />} />}>
								<Route path="save" element={<NotificationManagePage />} />
								<Route path="save/:id" element={<NotificationManagePage />} />
							</Route>

							<Route path="commission">
								<Route path="commissionDetail" element={<CommissionDetailPageRoute />} />
								<Route path="commissionPayoutHistory" element={<PersistentListRoute element={<CommissionPayoutHistoryPageRoute />} />}>
									<Route path="save" element={<CreateCommissionPayoutPageRoute />} />
									<Route path="save/:id" element={<CreateCommissionPayoutPageRoute />} />
									<Route path="view/:id" element={<CommissionPayoutViewPageRoute />} />
									<Route path="approved/:id" element={<CreateCommissionPayoutPageRoute />} />
								</Route>
							</Route>

							{/* 5. ດູແລລູກຄ້າ */}
							<Route path="callcenter">
								<Route path="accountService">
									<Route index element={<AccountServicePage />} />
								</Route>
								<Route path="customerService" element={<PersistentListRoute element={<CustomerServicePage />} />}>
									<Route path="save" element={<CustomerManagePage />} />
									<Route path="save/:id" element={<CustomerManagePage />} />
								</Route>
								<Route path="agentService" element={<PersistentListRoute element={<AgentServicePage />} />}>
									<Route path="save" element={<AgentServiceManagePage />} />
									<Route path="save/:id" element={<AgentServiceManagePage />} />
								</Route>
								<Route path="manualPayment" element={<ManualPaymentPage />} />
								<Route path="paymentHistory">
									<Route index element={<PaymentHistoryPage />} />
								</Route>
							</Route>

							{/* 6. ລາຍງານ */}
							<Route path="report">
								<Route path="vehicleInsuranceLink/:data" element={<VehicleContractReportPage />} />
								<Route path="customer" element={<CustomerReportPage />} />
								<Route path="agent" element={<AgentReportPage />} />
								<Route path="lifeInsurance" element={<LifeContractReportPage />} />
								<Route path="vehicleInsurance" element={<VehicleContractReportPage />} />
								<Route path="contractNearExpired" element={<ContractNearExpiredReportPage />} />
								<Route path="commissionAgent" element={<AgentCommissionReportPage />} />
								<Route path="riskVehicleContract" element={<RiskVehicleContractReportPage />} />
								<Route path="claimInsurance" element={<ClameReportPage />} />
								<Route path="vehicleReportClaimSummary" element={<VehicleReportClaimSummary />} />
								<Route path="vehicleReportSummary" element={<PersistentListRoute element={<VehicleReportSummary />} />}>
									<Route path="detail/:data" element={<VehicleContractReportPage />} />
								</Route>

							</Route>

							{/* 7. ດູແລລູກຄ້າ */}
							<Route path="setting">
								<Route path="redis" element={<RedisPage />} />
								<Route path="change-password" element={<ChangePasswordPage />} />

								<Route path="agentSpecialCommision" element={<PersistentListRoute element={<AgentSpecialCommisionPage />} />}>
									<Route path="save" element={<AgentSpecialCommisionManagePage />} />
									<Route path="save/:id" element={<AgentSpecialCommisionManagePage />} />
								</Route>

								<Route path="users" element={<PersistentListRoute element={<UserPage />} />}>
									<Route path="save" element={<UserManagePage />} />
									<Route path="save/:id" element={<UserManagePage />} />
								</Route>

								<Route path="vehicleBrand" element={<PersistentListRoute element={<VehicleBrandPage />} />}>
									<Route path="save" element={<VehicleBrandMangementPage />} />
									<Route path="save/:id" element={<VehicleBrandMangementPage />} />
								</Route>

								<Route path="policies" element={<PersistentListRoute element={<PoliciesPage />} />}>
									<Route path="save" element={<PoliciesMangementPage />} />
									<Route path="save/:id" element={<PoliciesMangementPage />} />
								</Route>

								<Route path="appControl" element={<PersistentListRoute element={<AppControlPage />} />}>
									<Route path="save" element={<AppControlManagePage />} />
									<Route path="save/:id" element={<AppControlManagePage />} />

								</Route>


								<Route path="userPermission" element={<PersistentListRoute element={<UserPermissionPage />} />}>
									<Route path="save" element={<UserPermissionManagePage />} />
									<Route path="save/:id" element={<UserPermissionManagePage />} />
									<Route path="webMenu" element={<WebMenuManagerPage />} />
								</Route>


								<Route path="actionLog" element={<ActionLogPage />} />

								<Route path="discounts" element={<PersistentListRoute element={<DiscountPage />} />}>
									<Route path="save" element={<DiscountManagePage />} />
									<Route path="save/:id" element={<DiscountManagePage />} />
								</Route>
							</Route>


							<Route path="users" element={<PersistentListRoute element={<UserPage />} />}>
								<Route path="add" element={<UserManagePage />} />
								<Route path="add/:id" element={<UserManagePage />} />
							</Route>

						</Route>
					</Routes>
					<ScrollTopBehaviour />
				</BrowserRouter>

				<GlobalDocumentPreview />
				<ToastContainer
					position="bottom-right"
					autoClose={3000}
					hideProgressBar={false}
					newestOnTop={false}
					closeOnClick
					rtl={false}
					pauseOnFocusLoss
					draggable
					pauseOnHover
					theme="colored"
				/>
				<ScrollToTop />
			</div>
		</>
	)
}

export default App
